import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { getArchivedProcedureList } from '../utils/urls';

import { ImportProcedureListType } from 'types/procedureBuilder';
import { ErrorModal } from 'types/modalTypes';

async function fetchArchivedProcedures({
  accountId,
}: TVariables): Promise<TResult> {
  const response = await fetch(getArchivedProcedureList(accountId), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: Array<ImportProcedureListType> | undefined;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  accountId: number;
};

function useGetArchivedProcedureList(
  accountId: number,
): UseQueryResult<TResult, TError> {
  return useQuery(
    ['get_archived_procedures', accountId],
    async () => {
      if (accountId)
        return await fetchArchivedProcedures({
          accountId,
        });
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetArchivedProcedureList };
